/* eslint-disable no-unused-vars */

export enum RequestStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  SUCCESS = 'completed',
  FAILED = 'failed',
}
